import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomerDataService {
  initalSelectedUnit;
  lastSelectedUnit;
  lastAccessUnitData;
  customerInfo;
  uniqueIdentifier;
  CustomerInfoList;
  customeRentalDetails: any;
  customerUnitDetails = [];
  customerDetailsForMoveOut;
  unitStatusForCustomerInfo;
  facilityName;
  LeaseId;
  Balance;
  LeaseStatus;
  moveOutData: any;
  refundItems = [];
  cusomerDashboardcaseEmitter: EventEmitter<any> = new EventEmitter();
  customerDashboardProfileEmitter = false;
  cuatomerInfoChangedEmitter: EventEmitter<any> = new EventEmitter();
  customerRentalUnitsInfoDetails: EventEmitter<any> = new EventEmitter();
  customermerchandiseSale = false;
  defaultUnitLoaded;
  contactInfoDetails;
  miscellaneousSettingsDetails: EventEmitter<any> = new EventEmitter();
  //////MandatoryFields Cache -- modify rental
  valueOfGoodsFields;
  vehiclesFormFeilds;
  scheduledMoveOutFormFields;
  rentRaiseFormFields;
  feeFormFields;
  //Auto Pay Details
  customerAutoPayDetails;
  leaseRestrictions;
  unitStatusForCustomerInfoEmitter: EventEmitter<any> = new EventEmitter();
  emitMiscSettings: EventEmitter<any> = new EventEmitter<any>();
  CustomerLateAndLienSetting = [];
  disableMoveout = false;

  constructor() { }

  flushCachedService() {
    this.valueOfGoodsFields = undefined;
    this.vehiclesFormFeilds = undefined;
    this.scheduledMoveOutFormFields = undefined;
    this.rentRaiseFormFields = undefined;
    this.CustomerLateAndLienSetting = [];
    this.initalSelectedUnit = null;
    this.lastSelectedUnit = null;
    this.lastAccessUnitData = null;
  }
}
